<template>
    <modal
        name="delete-employee-contract-form"
        class="modal--translation modal--hide-on-loading"
        v-cloak height="auto"
        :scrollable="false"
        :adaptive="false"
        :pivot-y="0.25"
    >
        <div class="modal-header">
            <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>

            <h5 class="modal-title mb-0"><i class="fa fa-exclamation-triangle mr-2"></i> {{ trans.title_delete_modal }}</h5>
        </div>

        <form></form>

        <div class="modal-footer text-center">
            <b-button type="button" variant="danger" @click="submitForm()" :class="{'loading disabled': loading }"><i class="fa fa-check mr-2"></i> {{ trans.saveBtn }}</b-button>
        </div>
    </modal>
</template>


<script>
export default {
    props: {
        'baseUrl': {
            type: String
        },
        'trans': {
            type: Object
        },
        'employeeContractId': {
            type: Number
        }
    },

    data: function() {
        return {
            loading: false,
        };
    },

    methods: {
        submitForm() {
            this.loading = true;

            axios.delete(this.baseUrl, {data: { id: this.employeeContractId } })
                .then(success => {
                    this.closeModal();
                    this.$notify({ type: 'success', title: success.data.message, text: success.data.message });
                    window.location.reload();
                    this.loading = false;
                })
                .catch(error => {
                    this.closeModal();
                    this.$notify({ type: 'error', title: error.response.data.message, text: error.response.data.error });
                    this.loading = false;
                });
        },

        closeModal() {
            this.$modal.hide('delete-employee-contract-form');
        },
    },
};
</script>

<style lang="scss" scoped>
    .modal-header {
        padding: 0;
        margin: 0;
        margin-bottom: 35px;
        border-bottom: 0;
    }
    h6.head-title {
        margin-bottom: 20px;
        font-size: 1.1rem;
    }
    .modal-footer {
        padding: 0;
        margin-top: 18px;
        border: 0;
    }
    .form-group {
        margin-bottom: 3px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/employee-contract/modals/DeleteEmployeeContractForm.vue